export default "__VITE_ASSET__e0166b58__"